<!-- PROGRESS BAR -->
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->

<!--  ROUTING OUTLET -->
<router-outlet></router-outlet>
<!-- / ROUTING OUTLET  -->
